import cn from 'classnames';
import { getProductImage, type Product } from '@/domain/Product';
import ProductImage from '../../parts/ProductImage/ProductImage.tsx';
import styles from './ProductImageSection.module.scss';
import SkeletonShape from '@/widgets/components/controls/Skeleton/SkeletonShape.tsx';

export type ProductImageSectionProps = {
  product: Product;
  width: number;
  class?: string;
  lazyLoadProductImage?: boolean;
};

export default function ProductImageSection({
  class: className,
  product,
  width,
  lazyLoadProductImage
}: ProductImageSectionProps) {
  const image = getProductImage(product, 'card');
  return (
    <ProductImage
      class={cn(styles.productImageContainer, className, {
        [styles.capsuleImage]: product.type === 'capsule',
        [styles.accessoryImage]: product.type === 'accessory'
      })}
      image={image}
      width={width}
      loading={lazyLoadProductImage ? 'lazy' : 'eager'}
    />
  );
}

ProductImageSection.Skeleton = function Skeleton() {
  return (
    <div class={styles.skeleton}>
      <SkeletonShape />
    </div>
  );
};
